// extracted by mini-css-extract-plugin
export var defaultStyles = "index-module--defaultStyles--YA8eA";
export var svg = "index-module--svg--9yCNM";
export var svgcontainer = "index-module--svgcontainer--HaYeV";